import { BehaviorSubject } from 'rxjs';

const subjectCorporatesFetched = new BehaviorSubject(false);
const subjectStoresCorporatesFetched = new BehaviorSubject(false);
const subjectFaqsFetched = new BehaviorSubject(false);
const subjectBlogsFetched = new BehaviorSubject(false);
const subjectContactFormFetched = new BehaviorSubject(false);
const subjectCorporateContentFetched = new BehaviorSubject(false);
const subjectLandingFetched = new BehaviorSubject(false);

const FaqsFetched = {
  update: fetched => {
    subjectFaqsFetched.next(fetched);
  },
};

const BlogsFetched = {
  update: fetched => {
    subjectBlogsFetched.next(fetched);
  },
};

const ContactFormFetched = {
  update: fetched => {
    subjectContactFormFetched.next(fetched);
  },
};

const CorporateContentFetched = {
  update: fetched => {
    subjectCorporateContentFetched.next(fetched);
  },
};
const LandingFetched = {
  update: fetched => {
    subjectLandingFetched.next(fetched);
  },
};

const CorporatesFetched = {
  update: fetched => {
    subjectCorporatesFetched.next(fetched);
  },
};
const StoresCorporatesFetched = {
  update: fetched => {
    subjectCorporatesFetched.next(fetched);
  },
};

const CorporateStore = {
  subject: new BehaviorSubject([]),
  update: corporates => {
    CorporateStore.subject.next(corporates);
    CorporatesFetched.update(true);
  },
  subscribe: setState => CorporateStore.subject.subscribe(setState),
  getValue: () => CorporateStore.subject.value,
  isFetched: () => subjectCorporatesFetched.value,
};

export const StoresCorporateStore = {
  subject: new BehaviorSubject([]),
  update: corporates => {
    StoresCorporateStore.subject.next(corporates);
    StoresCorporatesFetched.update(true);
  },
  subscribe: setState => StoresCorporateStore.subject.subscribe(setState),
  getValue: () => StoresCorporateStore.subject.value,
  isFetched: () => subjectStoresCorporatesFetched.value,
};

export const BlogStore = {
  subject: new BehaviorSubject([]),
  update: blogs => {
    BlogStore.subject.next(blogs);
    BlogsFetched.update(true);
  },
  subscribe: setState => BlogStore.subject.subscribe(setState),
  getValue: () => BlogStore.subject.value,
  isFetched: () => subjectBlogsFetched.value,
};
export const CorporateContentStore = {
  subject: new BehaviorSubject([]),
  update: corporatecontent => {
    CorporateContentStore.subject.next(corporatecontent);
    CorporateContentFetched.update(true);
  },
  subscribe: setState => CorporateContentStore.subject.subscribe(setState),
  getValue: () => CorporateContentStore.subject.value,
  isFetched: () => subjectCorporateContentFetched.value,
};
export const FaqsStore = {
  subject: new BehaviorSubject([]),
  update: faqs => {
    FaqsStore.subject.next(faqs);
    FaqsFetched.update(true);
  },
  subscribe: setState => FaqsStore.subject.subscribe(setState),
  getValue: () => FaqsStore.subject.value,
  isFetched: () => subjectFaqsFetched.value,
};
export const ContactFormStore = {
  subject: new BehaviorSubject([]),
  update: contactform => {
    ContactFormStore.subject.next(contactform);
    ContactFormFetched.update(true);
  },
  subscribe: setState => ContactFormStore.subject.subscribe(setState),
  getValue: () => ContactFormStore.subject.value,
  isFetched: () => subjectContactFormFetched.value,
};
export const LandingStore = {
  subject: new BehaviorSubject([]),
  update: landing => {
    LandingStore.subject.next(landing);
    LandingFetched.update(true);
  },
  subscribe: setState => LandingStore.subject.subscribe(setState),
  getValue: () => LandingStore.subject.value,
  isFetched: () => subjectLandingFetched.value,
};
export default CorporateStore;
